
import {
    useLayoutEffect
} from "react";
import {
    Image,
    TouchableOpacity,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    PageContainer,
    Text
} from "ncore-ui-kit";
import {
    useNavigation,
    useRoute,
    type RouteProp
} from "@react-navigation/native";
import {
    useSafeAreaInsets
} from "react-native-safe-area-context";
import type AppStackParamList from "../../../../../types/navigation/app";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import {
    ChevronLeft,
} from "lucide-react-native";

const CampaingDetail = () => {
    const navigation = useNavigation<NativeStackNavigationProp<AppStackParamList>>();
    const route = useRoute<RouteProp<AppStackParamList, "CampaingDetail">>();

    const {
        data
    } = route.params;

    const {
        radiuses,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const inset = useSafeAreaInsets();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: true,
            header: () => renderHeader()
        });
    }, [
        navigation
    ]);

    const renderHeader = () => {
        return <View
            style={[
                stylesheet.headerWrapper,
                {
                    paddingTop: inset.top + spaces.spacingMd,
                    paddingBottom: spaces.spacingMd,
                    paddingHorizontal: spaces.spacingMd,
                    backgroundColor: colors.content.container.default
                }
            ]}
        >
            <TouchableOpacity
                style={[
                    stylesheet.headerButton,
                    {
                        padding: spaces.spacingSm
                    }
                ]}
                onPress={() => {
                    navigation.goBack();
                }}
            >
                <ChevronLeft
                    size={30}
                />
            </TouchableOpacity>
        </View>;
    };

    const renderCoverImage = () => {
        return   <TouchableOpacity
            style={[
                stylesheet.coverImageWrapper,
                {
                    borderRadius: radiuses.form,
                    marginBottom: spaces.spacingMd
                }
            ]}
        >
            <Image
                source={{
                    uri: data.coverPhotoURL
                }}
                resizeMode="cover"
                style={[
                    stylesheet.coverImage,
                    {
                        borderRadius: radiuses.xl
                    }
                ]}
            />
            <View
                style={[
                    stylesheet.tagWrapper,
                    {
                        paddingHorizontal: spaces.spacingMd,
                        paddingVertical: spaces.spacingSm,
                        backgroundColor:colors.content.container.default,
                        borderRadius: radiuses.lg,
                        left: spaces.spacingMd,
                        top: spaces.spacingMd
                    }
                ]}
            >
                <Text
                    color="high"
                    variant="titleMediumSize"
                >
                    {data?.companyTitle}
                </Text>
            </View>
        </TouchableOpacity>;
    };

    return <PageContainer
        isScrollable={true}
    >
        {renderCoverImage()}
        <Text
            variant="titleLargeSize"
            style={{
                marginBottom: spaces.spacingMd
            }}
        >
            {data.title}
        </Text>
        <Text
            style={{
                marginBottom: spaces.spacingMd
            }}
            variant="bodyMediumSize"
            color="high"
        >
            {data.description}
        </Text>
    </PageContainer>;
};
export default CampaingDetail;
